export enum SceneEnum {
    INIT = 'init',
    PENDING = 'pending',
    CONTENT = 'content',
    FAILED = 'failed',
}
